export var IBrandLead;
(function (IBrandLead) {
    let Source;
    (function (Source) {
        /**
         * @deprecated
         */
        Source["BRAND_APPLIED"] = "BRAND_APPLIED";
        /**
         * @deprecated
         */
        Source["SALES"] = "SALES";
        Source["SALES_SOURCED"] = "SALES_SOURCED";
        Source["REFERRAL"] = "REFERRAL";
        Source["LEAD_GENIUS"] = "LEAD_GENIUS";
        Source["PRODUCT_MATCHING"] = "PRODUCT_MATCHING";
        Source["EVENT"] = "EVENT";
        Source["ORGANIC"] = "ORGANIC";
        Source["DIRECT_MAIL"] = "DIRECT_MAIL";
        Source["DIGITAL_ADS"] = "DIGITAL_ADS";
        Source["PRESS"] = "PRESS";
        Source["BRAND_REFERRAL"] = "BRAND_REFERRAL";
        Source["INTERNATIONAL_TRADESHOW"] = "INTERNATIONAL_TRADESHOW";
        Source["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
        Source["RETAILER_REFERRAL"] = "RETAILER_REFERRAL";
        Source["FAIRE_EMPLOYEE"] = "FAIRE_EMPLOYEE";
        Source["MAKER_SCORING"] = "MAKER_SCORING";
        Source["CHARM_IO"] = "CHARM_IO";
        Source["OUTBOUND"] = "OUTBOUND";
        Source["OUTBOUND_OLD"] = "OUTBOUND_OLD";
        Source["FAIRE_BLOG"] = "FAIRE_BLOG";
        Source["ZOOMINFO"] = "ZOOMINFO";
        Source["PURCHASE_ORDER"] = "PURCHASE_ORDER";
    })(Source = IBrandLead.Source || (IBrandLead.Source = {}));
    /**
     * Return an instance of IBrandLead with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IBrandLead.build = (partial) => (Object.assign({ secondary_categories: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IBrandLead || (IBrandLead = {}));
